import { In } from 'typeorm'

import { User } from '@things-factory/auth-base'
import {
  Activity,
  ActivityInstance,
  ActivityInstanceStatus,
  UpdateActivityInstanceStateAddendum
} from '@things-factory/worklist'
import { NewDataSample } from '../service/data-sample/data-sample-type.js'
import { createDataSample } from '../controllers/create-data-sample.js'

async function callback(
  activityInstance: ActivityInstance,
  addendum: UpdateActivityInstanceStateAddendum,
  context: ResolverContext
) {
  const { domain, tx } = context.state
  const { input, output, state } = activityInstance

  if (state == ActivityInstanceStatus.Ended) {
    const activity = (await tx.getRepository(Activity).findOneBy({
      domain: { id: In([domain.id, domain.parentId].filter(Boolean)) },
      name: 'Collect Data'
    })) as Activity

    /* collect-data 액티비티는 한명의 assignee(thread)만 수행하는 multiple: false 액티비티이다. 따라서, output에는 assignee key가 없이, 순수한 data만 들어있다. */
    const data = output

    if (activity) {
      const dataSample: NewDataSample = {
        dataSet: {
          id: input.dataSetId
        },
        data
      }

      await createDataSample(dataSample, context)
    } else {
      console.error('Collect Data Activity not installed.')
    }
  }
}

export const ActivityDataCollect = {
  name: 'Collect Data',
  description: 'Tasks assigned for data collection',
  release: '1.0.0',
  provider: 'hatiolab.com',
  category: 'quality',
  activityType: 'user',
  priority: 1,
  searchKeys: [
    {
      name: 'dataSetName',
      description: 'DataSet name',
      inputKey: 'dataSetName',
      tKey: 'data-set-name'
    }
  ],
  startingType: '',
  multiple: 'single',
  model: [
    {
      name: 'dataSetId',
      description: 'DataSet Id.',
      tag: 'dataSetId',
      hidden: true,
      mandatory: true,
      inout: 'in',
      type: 'string',
      options: {},
      unit: null,
      quantifier: [1],
      spec: {}
    },
    {
      name: 'dataSetName',
      description: 'DataSet name',
      tag: 'dataSetName',
      hidden: true,
      mandatory: true,
      inout: 'in',
      type: 'string',
      options: {},
      unit: null,
      quantifier: [1],
      spec: {}
    }
  ],
  uiType: 'custom-element',
  uiSource: 'activity-data-collect-edit',
  viewType: 'custom-element',
  viewSource: 'activity-data-collect-view',
  reportType: 'custom-element',
  reportSource: 'activity-data-collect-view',
  thumbnail: '/assets/images/data-collect.png',
  standardTime: 24 * 60 * 60, // seconds
  callback /* Called when there is a change in the lifecycle of a task (activity-instance). */
}
